
const billingRoutes = [
    {
        path:'requestPayment',
        name:'billing-requestPayment',
        component: () => import(/* webpackChunkName: "about" */ '@/views/billing/requestPayment.vue')
    },
    {
        path: 'platformPayment',
        name:'billing-platformPayment',
        component: () => import(/* webpackChunkName: "about" */ '@/views/billing/platformPayment.vue')
    }
]
export default billingRoutes